import { BaseAPI } from '@/lib/api';

export interface SearchRequest {
  query: string;
}

export interface SearchResponse {
  success: boolean;
  results_count: number;
  query_time_ms: number;
  results_by_source: Record<string, any[]>;
  operator_info?: {
    phone: string;
    operator: string;
    region: string;
    country: string;
  };
  error?: string;
}

export interface SearchStats {
  success: boolean;
  stats?: {
    today_searches: number;
    total_searches: number;
    requests_left: number;
    user_role: string;
  };
  error?: string;
}

export interface ParsedQuery {
  success: boolean;
  parsed?: {
    phones: string[];
    inns: string[];
    exact_date: string | null;
    partial_date: string | null;
    fio: {
      last_name: string | null;
      first_name: string | null;
      patronymic: string | null;
    };
    emails: string[];
  };
  error?: string;
}

class SearchAPI extends BaseAPI {

  async performSearch(query: string): Promise<SearchResponse> {
    return this.makeRequest<SearchResponse>('/api/search/perform', {
      method: 'POST',
      body: JSON.stringify({ query }),
    });
  }

  async getSearchStats(): Promise<SearchStats> {
    return this.makeRequest<SearchStats>('/api/search/stats');
  }

  async parseQuery(query: string): Promise<ParsedQuery> {
    return this.makeRequest<ParsedQuery>('/api/search/parse_query', {
      method: 'POST',
      body: JSON.stringify({ query }),
    });
  }

  async checkPhoneOperator(phone: string): Promise<{
    success: boolean;
    operator_info?: {
      phone: string;
      operator: string;
      region: string;
      country: string;
    };
    error?: string;
  }> {
    return this.makeRequest('/api/search/check_operator', {
      method: 'POST',
      body: JSON.stringify({ phone }),
    });
  }

  async getFieldLabels(): Promise<{
    success: boolean;
    field_labels: Record<string, string>;
  }> {
    return this.makeRequest('/api/search/field_labels');
  }

  async getSearchExamples(): Promise<{
    success: boolean;
    examples: Array<{
      category: string;
      examples: string[];
    }>;
  }> {
    return this.makeRequest('/api/search/examples');
  }

  async healthCheck(): Promise<{
    success: boolean;
    status: string;
    timestamp: number;
  }> {
    return this.makeRequest('/api/search/health');
  }
}

export const searchAPI = new SearchAPI();
